const BREAKPOINTS = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};

export default {
    created() {
        window.addEventListener('resize', this.$_handleResize);
        this.$_handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.$_handleResize);
    },
    data: () => ({
        currentBreakpoint: 'xs',
    }),
    computed: {
        $mq() {
            return this.currentBreakpoint;
        }
    },
    methods: {
        $_handleResize() {
            const width = window.innerWidth;
            let breakpoint = null;

            Object.keys(BREAKPOINTS).forEach(key => {
                if (width >= BREAKPOINTS[key]) {
                    breakpoint = key;
                }
            });

            this.currentBreakpoint = breakpoint;
        },
        $mqIn(breakPoints) {
            return breakPoints.includes(this.currentBreakpoint);
        }
    }
};